(function () {
  function initPatternSwatches(root) {
    if (!root || root.dataset.runasInit === '1') return;
    root.dataset.runasInit = '1';

    const scope =
      root.closest('.quick-add-modal__content-info') ||
      root.closest('[id^="MainProduct-"]') ||
      root.closest('section') ||
      document;

    const formId = root.getAttribute('data-product-form-id');
    const swatchOptionName = (root.getAttribute('data-swatch-option-name') || '').trim().toLowerCase();

    function getVariantJson() {
      const jsonEl = scope.querySelector('script[id^="VariantData-"]');
      if (!jsonEl) return [];
      try {
        return JSON.parse(jsonEl.textContent);
      } catch (e) {
        return [];
      }
    }

    function getSelectedColorFromSwatches() {
      const active = root.querySelector('.pattern-swatch.is-active');
      return active ? (active.getAttribute('data-color-value') || '').trim() : null;
    }

    function getOtherSelectedOptionValue() {
      const fieldsets = Array.from(scope.querySelectorAll('variant-radios fieldset'));
      for (const fs of fieldsets) {
        const legend = fs.querySelector('legend');
        if (!legend) continue;

        const legendText = (legend.textContent || '').trim().toLowerCase();
        if (legendText === swatchOptionName) continue;

        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) return (checked.value || '').trim();
      }
      return null;
    }

    function setActiveSwatch(colorValue) {
      root.querySelectorAll('.pattern-swatch').forEach((btn) => {
        const isActive = btn.getAttribute('data-color-value') === colorValue;
        btn.classList.toggle('is-active', isActive);

        if (isActive) {
          btn.style.outline = '2px solid rgba(0,0,0,.6)';
          btn.style.outlineOffset = '2px';
        } else {
          btn.style.outline = 'none';
          btn.style.outlineOffset = '0';
        }
      });
    }

    function getColorFieldset() {
      return Array.from(scope.querySelectorAll('variant-radios fieldset')).find((fs) => {
        const legend = fs.querySelector('legend');
        return legend && (legend.textContent || '').trim().toLowerCase() === swatchOptionName;
      });
    }

    function clickThemeColor(colorValue) {
      const colorFieldset = getColorFieldset();
      if (!colorFieldset) return false;

      const input = colorFieldset.querySelector(`input[type="radio"][value="${CSS.escape(colorValue)}"]`);
      if (!input) return false;

      const label = colorFieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);

      if (label) {
        label.click();
      } else {
        input.click();
      }

      return true;
    }

    function setAddToCartVariantId(variantId) {
      const form =
        (formId && document.getElementById(formId)) ||
        scope.querySelector('product-form form') ||
        scope.querySelector('form[action*="/cart/add"]');

      if (!form) return false;

      const idInput = form.querySelector('input[name="id"]');
      if (!idInput) return false;

      idInput.value = String(variantId);
      idInput.disabled = false;
      idInput.dispatchEvent(new Event('input', { bubbles: true }));
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    function syncVariantId() {
      const color = getSelectedColorFromSwatches();
      const otherOption = getOtherSelectedOptionValue();
      const variants = getVariantJson();

      if (!color || !otherOption || !variants.length) return;

      const match = variants.find((v) => {
        const opts = (v.options || []).map(x => (x || '').trim());
        return opts.includes(color) && opts.includes(otherOption);
      });

      if (!match) return;

      setAddToCartVariantId(match.id);
    }

    root.addEventListener('click', function (e) {
      const btn = e.target.closest('.pattern-swatch');
      if (!btn) return;

      e.preventDefault();

      const colorValue = (btn.getAttribute('data-color-value') || '').trim();
      if (!colorValue) return;

      setActiveSwatch(colorValue);
      clickThemeColor(colorValue);

      setTimeout(syncVariantId, 0);
    });

    scope.addEventListener('change', function () {
      const colorFieldset = getColorFieldset();
      if (colorFieldset) {
        const checked = colorFieldset.querySelector('input[type="radio"]:checked');
        if (checked && checked.value) {
          setActiveSwatch((checked.value || '').trim());
        }
      }

      syncVariantId();
    });

    const initialColor = getSelectedColorFromSwatches();
    if (initialColor) {
      setActiveSwatch(initialColor);
    } else {
      const colorFieldset = getColorFieldset();
      if (colorFieldset) {
        const checked = colorFieldset.querySelector('input[type="radio"]:checked');
        if (checked && checked.value) {
          setActiveSwatch((checked.value || '').trim());
        }
      }
    }

    syncVariantId();
  }

  function initAllPatternSwatches(context) {
    const roots = (context || document).querySelectorAll('.pattern-swatches');
    roots.forEach(initPatternSwatches);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllPatternSwatches(document);
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches && node.matches('.pattern-swatches')) {
          initPatternSwatches(node);
        } else if (node.querySelectorAll) {
          initAllPatternSwatches(node);
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();